import { types } from 'mobx-state-tree';

import OrderAlertTypes, { OrderAlertType } from '../../types/order/OrderAlert';

const MessageData = types
  .model('MessageData', {
    allowHtml: types.optional(types.boolean, false),
    id: types.maybeNull(types.string),
    defaultMessage: types.string,
    forceRefresh: types.optional(types.boolean, false),
    isOpen: types.optional(types.boolean, false),
    type: types.optional(OrderAlertType, OrderAlertTypes.DANGER),
  })
  .views((self) => {
    return {
      get isTranslatable() {
        return self.id?.length > 0;
      },
      get hasContent() {
        return self.defaultMessage.length > 0;
      },
    };
  });

const UserMessage = types.optional(MessageData, {
  allowHtml: false,
  id: '',
  defaultMessage: '',
  forceRefresh: false,
  type: OrderAlertTypes.DANGER,
});

export default UserMessage;
